import React, {Fragment, useEffect, useState} from 'react'
import {reqImportCustomsPorts, reqImportPackages,} from '../../api'
import {Form, Table, message, Row, Col,} from 'antd';
import 'moment/locale/zh-cn';
import {
    I_DELIVERY_TYPE, I_ENTRUST_TYPE_YIN, I_SUB_TYPE_YIT
} from "../../utills/constants";

export default function ImportOrderView(props) {
    const {order} = props
    //数据源
    const [customsPortObj, setCustomsPortObj] = useState({});
    //商品信息
    const [dataSource, setDataSource] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    useEffect(() => {
        if (order && order.id) {
            getCustomsPorts(order.deliveryType)
            getImportPackages()//商品
        }
    }, [order]);
    //口岸
    const getCustomsPorts = async (deliveryType) => {
        let result = await reqImportCustomsPorts(deliveryType);
        if (result.code === 200) {
            const obj = {}
            result.data.forEach(o => {
                obj[o.customsPortCode] = o.customsPortName
            })
            setCustomsPortObj(obj)
        } else {
            message.error(result.message)
        }
    }
    const getImportPackages = async (pageNum = 1, pageSize = 10) => {
        const po = {orderId: order.id, pageNum, pageSize,}
        let result = await reqImportPackages(po);
        if (result.code == 200) {
            setPageNum(pageNum);
            setPageSize(pageSize)
            setDataSource(result.data.rows);
            setTotal(result.data.total);
        } else {
            message.error(result.message)
        }
    };
    const columns = [{
        title: '商品编号',
        dataIndex: 'hscode',
    }, {
        title: '商品名称',
        dataIndex: 'name',
    }, {
        title: '规格型号',
        dataIndex: 'spec',
    }, {
        title: '产地',
        dataIndex: 'madeIn',
    }, {
        title: '数量',
        dataIndex: 'num',
    }, {
        title: '单位',
        dataIndex: 'unit',
    }, {
        title: '净重KG',
        dataIndex: 'netWeight',
    }, {
        title: '毛重KG',
        dataIndex: 'grossWeight',
    }, {
        title: '件数',
        dataIndex: 'pcsNumber',
    }, {
        title: '包装种类',
        dataIndex: 'packageType',
    }];
    const listFormItemLayout = {
        labelCol: {lg: {span: 4}, md: {span: 8},},
        wrapperCol: {lg: {span: 20}, md: {span: 16},},
    }
    return (
        <div className='order-space info-content'>
            <div className="order-base-title">委托类型</div>
            <div className='order-info-details-no-border'>
                <Row className='order-info-item'>
                    <Col span={8}>
                        <span className='label'>运输类型：</span>
                        <span>{I_DELIVERY_TYPE[order.deliveryType]}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>委托方式：</span>
                        <span>{I_ENTRUST_TYPE_YIN[order.entrustType]}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>入境口岸：</span>
                        <span>{customsPortObj[order.customsPort]}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>预计抵达时间：</span>
                        <span>{order.estimatePortDt}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>服务类型：</span>
                        <span>{I_SUB_TYPE_YIT[order.subType]}</span>
                    </Col>
                    {order.deliveryType === 'YIT' && <Col span={8}>
                        <span className='label'>倒装车型：</span>
                        <span>{order.cabinetType}</span>
                    </Col>}
                    {order.entrustType === 'p2w' && <Col span={8}>
                        <span className='label'>目的地：</span>
                        <span>{order.destinationCity}</span>
                    </Col>}
                </Row>
            </div>
            <div className='order-base-title'>箱货信息</div>
            <div className='order-info-details-no-border'>
                <Row className='order-info-item'>
                    <Col span={8}>
                        <span className='label'>集装箱号：</span>
                        <span>{order.boxNo}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>铅封号：</span>
                        <span>{order.sealNo}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>件数：</span>
                        <span>{order.pcsNumber}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>重量：</span>
                        <span>{order.weight}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>提单号：</span>
                        <span>{order.ladingBillNo}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>箱单号：</span>
                        <span>{order.boxNoteNo}</span>
                    </Col>
                </Row>
            </div>
            <div className='order-base-title'>清关/转关商品信息</div>
            <div className='spaceInfo-content-info'>
                <Table
                    rowKey='id'
                    size="middle"
                    bordered
                    columns={columns}
                    dataSource={dataSource}
                    pagination={{
                        current: pageNum,
                        total: total,
                        showQuickJumper: true,
                        onChange: (pageNum) => getImportPackages(pageNum)
                    }}
                />
            </div>
            <div className='order-base-title'>国内仓库信息</div>
            <div className='order-info-details-no-border'>
                <Row className='order-info-item'>
                    <Col span={8}>
                        <span className='label'>地址：</span>
                        <span>{order.storageAddr}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>联系人：</span>
                        <span>{order.storageContact}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>联系方式：</span>
                        <span>{order.storageTel}</span>
                    </Col>
                </Row>
            </div>
        </div>
    )
}